export default "__VITE_ASSET__CmQx7JIN__"